import React from "react";
 
interface Period {
  calendarName: string;
  calendarMonth: string;
  calendarYear: string;
}
 
interface Props {
  periods: Period[];
}
 
const QuarterlyPeriodsList: React.FC<Props> = ({ periods }) => {

  return (
    <div>
      <ul>
        {periods.map((period, index) => (
          <li key={index}>
            {period.calendarName} ({period.calendarMonth}) {period.calendarYear}
          </li>
        ))}
      </ul>
    </div>
  );
};
 
export default QuarterlyPeriodsList;
